@if (formName && controlName) {
  <ng-container [formGroup]="formName">
    <kendo-dropdownlist
      [ngStyle]="{ width: '100%' }"
      [data]="dropdownData"
      [itemDisabled]="itemDisabled"
      textField="text"
      valueField="value"
      [formControlName]="controlName"
      class="status-dropdown"
      [value]="selectedValue"
      (valueChange)="onValueChange($event)">
      <ng-template kendoDropDownListItemTemplate let-statusItem>
        @if (topicTypeId && statusItem?.value) {
          <ti-status
            [status]="statusItem?.text"
            [blockHeight]="20"
            [topicTypeId]="topicTypeId"
            [statusId]="statusItem?.value"></ti-status>
        }
        @if (entityName && statusItem?.value) {
          <ti-status
            [status]="statusItem?.text"
            [blockHeight]="20"
            [entityName]="entityName"
            [statusId]="statusItem?.value"></ti-status>
        }
        @if (!topicTypeId && !entityName) {
          <ti-status [status]="statusItem?.text" [blockHeight]="20"></ti-status>
        }
      </ng-template>

      <ng-template kendoDropDownListValueTemplate let-statusItem>
        @if (topicTypeId && statusItem?.value) {
          <ti-status
            [status]="statusItem?.text"
            [blockHeight]="20"
            [topicTypeId]="topicTypeId"
            [statusId]="statusItem?.value"></ti-status>
        }
        @if (entityName && statusItem?.value) {
          <ti-status
            [status]="statusItem?.text"
            [blockHeight]="20"
            [entityName]="entityName"
            [statusId]="statusItem?.value"></ti-status>
        }
        @if (!topicTypeId && !entityName) {
          <ti-status [status]="statusItem?.text" [blockHeight]="20"></ti-status>
        }
      </ng-template>
    </kendo-dropdownlist>
  </ng-container>
}

@if (!formName && !controlName) {
  <kendo-dropdownlist
    [ngStyle]="{ width: '100%' }"
    [data]="dropdownData"
    textField="text"
    valueField="value"
    class="status-dropdown"
    [itemDisabled]="itemDisabled"
    [disabled]="disabled"
    [value]="selectedValue"
    (valueChange)="onValueChange($event)">
    <ng-template kendoDropDownListItemTemplate let-statusItem>
      @if (topicTypeId && statusItem?.value) {
        <ti-status
          [status]="statusItem?.text"
          [blockHeight]="20"
          [topicTypeId]="topicTypeId"
          [statusId]="statusItem?.value"></ti-status>
      }
      @if (entityName && statusItem?.value) {
        <ti-status
          [status]="statusItem?.text"
          [blockHeight]="20"
          [entityName]="entityName"
          [statusId]="statusItem?.value"></ti-status>
      }
      @if (!topicTypeId && !entityName) {
        <ti-status
          [status]="statusItem?.text"
          [blockHeight]="20"
          [forceColor]="statusItem?.color"></ti-status>
      }
    </ng-template>

    <ng-template kendoDropDownListValueTemplate let-statusItem>
      @if (topicTypeId && statusItem?.value) {
        <ti-status
          [status]="statusItem?.text"
          [blockHeight]="20"
          [topicTypeId]="topicTypeId"
          [statusId]="statusItem?.value"></ti-status>
      }
      @if (entityName && statusItem?.value) {
        <ti-status
          [status]="statusItem?.text"
          [blockHeight]="20"
          [entityName]="entityName"
          [statusId]="statusItem?.value"></ti-status>
      }
      @if (!topicTypeId && !entityName) {
        <ti-status
          [status]="statusItem?.text"
          [blockHeight]="20"
          [forceColor]="statusItem?.color"></ti-status>
      }
    </ng-template>
  </kendo-dropdownlist>
}
